import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import './App.css';
import ChatSupport from './ChatSupport';
import Documentation from './Documentation';
import FAQ from './FAQ';
import TermsConditions from './TermsConditions';
import PrivacyPolicy from './PrivacyPolicy';
import EmbedRewarded from './EmbedRewarded';
import ComprasLoader from './ComprasLoader';
import QuoteRequestForm from './sections/QuoteRequestForm';

import Hero            from './sections/Hero';
import TrustStrip      from './sections/TrustStrip';
import HowItWorks      from './sections/HowItWorks';
import Features        from './sections/Features';
import ComprasModule   from './sections/ComprasModule';
import DesktopShowcase from './sections/DesktopShowcase';
import TrustBanner     from './sections/TrustBanner';
import Pricing         from './sections/Pricing';
import Testimonials    from './sections/Testimonials';
import FinalCta        from './sections/FinalCta';
import SiteFooter      from './sections/SiteFooter';
import FloatingFabs    from './sections/FloatingFabs';
import DownloadModal   from './sections/DownloadModal';

function HomePage() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  // Preserve the legacy `#soporte` deep-link → opens chat drawer
  useEffect(() => {
    const checkHash = () => {
      if (window.location.hash === '#soporte') {
        setIsChatOpen(true);
        window.history.replaceState(null, null, window.location.pathname + window.location.search);
      }
    };
    checkHash();
    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);

  const openDownload = () => setShowDownloadModal(true);
  const openChat     = () => setIsChatOpen(true);

  return (
    <div className="min-h-screen bg-white font-sans">
      <DownloadModal isOpen={showDownloadModal} onClose={() => setShowDownloadModal(false)} />

      <Hero            onOpenDownload={openDownload} />
      <TrustStrip />
      <HowItWorks />
      <Features />
      <ComprasModule />
      <DesktopShowcase />
      <TrustBanner />
      <Pricing         onOpenDownload={openDownload} />
      <Testimonials />
      <FinalCta        onOpenDownload={openDownload} />

      <SiteFooter      onOpenChat={openChat} />

      <FloatingFabs    onOpenChat={openChat} />
      <ChatSupport isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/contact" element={<Navigate to="/cotizacion" replace />} />
      <Route path="/documentacion" element={<Documentation />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/terminos-y-condiciones" element={<TermsConditions />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/privacidad" element={<PrivacyPolicy />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/embed/rewarded" element={<EmbedRewarded />} />
      <Route path="/compras-loader" element={<ComprasLoader />} />
      <Route path="/cotizacion" element={<QuoteRequestForm />} />
    </Routes>
  );
}

export default App;
